import { render, staticRenderFns } from "./ConfirmArea.vue?vue&type=template&id=7ed638fa&scoped=true&"
import script from "./ConfirmArea.vue?vue&type=script&lang=js&"
export * from "./ConfirmArea.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmArea.vue?vue&type=style&index=0&id=7ed638fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed638fa",
  null
  
)

export default component.exports